<div class="just-flex" (click)="dateRange.pickRange($event)">
	<ng-container>
		<ion-label>{{ displayValue }}</ion-label>
		<calao-date-range-picker #dateRange [(model)]="value" (dateRangeChanged)="onDateRangeChanged($event)" hidden>
		</calao-date-range-picker>
	</ng-container>
</div>